import { render } from "./learnerFeedbackView.vue?vue&type=template&id=7446a49a&scoped=true"
import script from "./learnerFeedbackView.vue?vue&type=script&lang=js"
export * from "./learnerFeedbackView.vue?vue&type=script&lang=js"

import "./learnerFeedbackView.vue?vue&type=style&index=0&id=7446a49a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7446a49a"]])

export default __exports__